// src/store/projectsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {  getProjects } from '../../api/projectsApi';

export const fetchProjects = createAsyncThunk(
  'projects/fetchProjects',
  async (adminId, { rejectWithValue }) => {
    try {
      const projects = await getProjects(adminId);
      return projects || []; 
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    projects: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProjects.fulfilled, (state, action) => {
        state.loading = false;
        state.projects = action.payload;
      })
      .addCase(fetchProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default projectsSlice.reducer;
